import { lazy } from 'react';

export { ContractNew } from './contract-new';

export const LazyContractNew = lazy(() => import('./contract-new').then((mod) => ({ default: mod.ContractNew })));
